import _ from 'lodash';
import { getField, updateField } from 'vuex-map-fields';
const state = {
    link_tucarro: null,
    link_olx: null,
    link_instagram: null,
    link_facebook: null,
    link_pais: null
};
const mutations = {
    updateField,
    updatePublicacion: (state, payload) => {
        var size = Object.keys(payload.publicacion).length;
        if(size > 0){
            state.link_tucarro = payload.publicacion.link_tucarro;
            state.link_olx = payload.publicacion.link_olx;
            state.link_instagram = payload.publicacion.link_instagram;
            state.link_facebook = payload.publicacion.link_facebook;
            state.link_pais = payload.publicacion.link_pais;
        }
    }
};

const getters = {
    getField
};

const actions = {

};

export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
}
